import { Icon, IconProps, Popover, PopoverProps } from "@amzn/awsui-components-react";

/**
 * Props for the CustomPopOver component.
 * @interface
 * @property {IconProps.Name} icon - Optional icon to display in the popover trigger (defaults to "status-info")
 * @property {React.ReactNode} content - Content to display inside the popover
 * @property {PopoverProps.Size} size - Optional size of the popover
 */
export interface CustomPopOverProps {
    icon?: IconProps.Name;
    content: React.ReactNode;
    size?: PopoverProps.Size;
}

/**
 * Component that displays an icon which shows a popover when clicked
 *
 * @param {IconProps.Name} icon - Icon to display as the popover trigger (defaults to "status-info")
 * @param {React.ReactNode} content - Content to display inside the popover
 * @param {PopoverProps.Size} size - Size of the popover
 *  
 * @returns {JSX.Element} - The rendered popover component
 */
const CustomPopOver = ({ icon = "status-info", content, size }: CustomPopOverProps) => {
    const POP_OVER_POSITION: PopoverProps.Position = "top";

    const ICON_SIZE: IconProps.Size = "small";

    return (
        <Popover
            dismissButton={false}
            position={POP_OVER_POSITION}
            size={size}
            wrapTriggerText={false}
            content={content}
        >
            <Icon name={icon} size={ICON_SIZE} />
        </Popover>
    );
};

export default CustomPopOver;
